import type { MagentoApiSetShippingAddressesOnCartMutationResponse } from "@jti/magento-api-v2";
import type { ApiMagentoAddress } from "@jti/magento-types";

import { TAGS } from "../common/tags";
import type { MagentoApiBuilder } from "../magentoApiSlice";

type SetShippingAddressOnCartPayload = {
  cartId: string;
  address: ApiMagentoAddress;
};

export const setShippingAddressOnCartEndpoint = (builder: MagentoApiBuilder) => ({
  setShippingAddressOnCart: builder.mutation<
    MagentoApiSetShippingAddressesOnCartMutationResponse,
    SetShippingAddressOnCartPayload
  >({
    query: ({ cartId, address }) => ({
      method: "setShippingAddressesOnCart",
      params: [{ cartId, address }],
    }),
    invalidatesTags: [TAGS.ORDER_DELIVERY_LIMITS, TAGS.CART_ITEMS, TAGS.CART_ORDER_PRICES, TAGS.SHIPPING_METHODS],
  }),
});
